/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectDurationResource
 */
export interface ProjectDurationResource {
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDurationResource
     */
    fixed: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProjectDurationResource
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectDurationResource
     */
    unit: ProjectDurationResourceUnitEnum;
}


/**
 * @export
 */
export const ProjectDurationResourceUnitEnum = {
    Days: 'DAYS',
    Weeks: 'WEEKS',
    Months: 'MONTHS'
} as const;
export type ProjectDurationResourceUnitEnum = typeof ProjectDurationResourceUnitEnum[keyof typeof ProjectDurationResourceUnitEnum];


/**
 * Check if a given object implements the ProjectDurationResource interface.
 */
export function instanceOfProjectDurationResource(value: object): value is ProjectDurationResource {
    if (!('fixed' in value) || value['fixed'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    return true;
}

export function ProjectDurationResourceFromJSON(json: any): ProjectDurationResource {
    return ProjectDurationResourceFromJSONTyped(json, false);
}

export function ProjectDurationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDurationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'fixed': json['fixed'],
        'value': json['value'],
        'unit': json['unit'],
    };
}

export function ProjectDurationResourceToJSON(value?: ProjectDurationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fixed': value['fixed'],
        'value': value['value'],
        'unit': value['unit'],
    };
}

